<template>
    <b-modal
        id="treatementAdmit"
        ref="treatementAdmit"
        :lazy="true"
        @shown="shown"
        @hidden="hidden"
        title-tag="h2"
        title="Admit Patient"
    >
        <b-form>
            <b-form-group
                label="Patient:"
                class
                label-cols="3"
                label-for="patient_id"
            >
                <vet-select
                    id="patient_id"
                    v-model="data.patient"
                    v-validate="'required'"
                    :class="{
                        'border-danger': errors.has('patient_id'),
                        rounded: true
                    }"
                    :show-menu="false"
                    module="patient-treament-board"
                    placeholder="Patient Name (required)"
                    label="fullname"
                    name="patient_id"
                />
            </b-form-group>
            <b-form-group
                label="Triage:"
                class
                label-cols="3"
                label-for="triage_type_id"
            >
                <select
                    id="triage_type_id"
                    v-model="data.triage_type_id"
                    class="form-control"
                    name="triage_type_id"
                >
                    <option v-if="triageOptions.length === 0" disabled
                        >Loading</option
                    >
                    <option
                        v-for="triage in triageOptions"
                        :key="triage.id"
                        :value="triage.id"
                        >{{ triage.triage }}</option
                    >
                </select>
            </b-form-group>
            <b-form-group
                label="Admitted For: "
                class
                label-cols="3"
                label-for="notes"
            >
                <input
                    id="notes"
                    v-model="data.note"
                    v-validate="'required'"
                    :class="{ 'border-danger': errors.has('notes') }"
                    class="form-control"
                    placeholder="Admitted for (required)"
                    rows="3"
                    name="notes"
                />
            </b-form-group>
            <b-form-group :label-for="`room`" :label-cols="3" label="Room:">
                <b-form-select v-model="data.room" :options="rooms" name="room">
                    <!-- <option :value="0">Select room (optional)</option> -->
                </b-form-select>
            </b-form-group>
            <b-form-group
                :label-for="`staffs`"
                :label-cols="3"
                label="Assign To:"
            >
                <v-select
                    id="staffs"
                    ref="vselect"
                    :class="{ 'border-danger': errors.has('staffs') }"
                    :options="staff_options_exclude"
                    v-model="data.staffs"
                    :label="'fullname'"
                    name="staffs"
                    multiple
                    aria-placeholder="true"
                    placeholder="Assign to (optional)"
                ></v-select>
            </b-form-group>
            <b-form-group :label-cols="3">
                <b-form-checkbox
                    id="startTreatment"
                    v-model="data.startTreatment"
                    name="startTreatment"
                    plain
                    class="col-form-label pt-0"
                >
                    <span class="fw-normal">Start treatment</span>
                </b-form-checkbox>
            </b-form-group>
        </b-form>
        <div slot="modal-footer" class="w-100">
            <b-button
                v-if="!loading"
                @click="$refs.treatementAdmit.hide('cancel')"
                class="float-left"
                variant="secondary"
                >Cancel</b-button
            >
            <div class="float-right">
                <img v-if="loading" src="assets/ajax-loader.gif" />
                <b-button
                    v-if="!loading"
                    @click="save"
                    class="float-left"
                    variant="primary"
                    >{{
                        data.startTreatment ? "Save + Start Treatment" : "Save"
                    }}</b-button
                >
            </div>
        </div>
    </b-modal>
</template>
<style></style>
<script>
import vSelect from "vue-select";
import vetSelect from "@/module/commons/vet-select.vue";
import { difference } from "lodash";
import TriageService from "@/services/triage";

export default {
    name: "TreatementAdmit",
    components: {
        vSelect,
        vetSelect
    },
    data() {
        return {
            loading: false,
            data: {
                patient: null,
                room: 0,
                staffs: [],
                notes: "",
                triage_type_id: 5,
                startTreatment: true
            },
            rooms: [],
            staffList: [],
            triageOptions: [],
            start_treatment_data: {
                patient: {},
                treatment: {},
                clientID: "",
                treatmentID: ""
            }
        };
    },
    computed: {
        // TODO: will be moved to helper component soon
        staff_options_exclude() {
            return difference(this.staffList, this.data.staffs);
        }
    },
    mounted() {
        this.patient_id = this.data.patient_id;
    },
    beforeRouteEnter(to, from, next) {
        next(self => self.$refs["treatementAdmit"].show());
    },
    methods: {
        open() {
            this.$refs["treatementAdmit"].show();
        },
        shown() {
            this.getStaffList();
            this.getRooms();
            this.getTriageList();
        },
        hidden() {
            if (this.$route.path === "/schedule/treatment/admit") {
                this.$router.replace("/schedule/treatment");
            }
        },
        getRooms() {
            let self = this;
            return this.$http
                .get(process.env.SCHEDULE_SERVICE + "rooms")
                .then(function (response) {
                    if (response.data.response.resources)
                        self.rooms = [
                            { value: "0", text: "Select room (optional)" },
                            ...response.data.response.resources.map(room => ({
                                value: room.id,
                                text: room.name
                            }))
                        ];
                });
        },
        getStaffList() {
            let self = this;
            return this.$http
                .get(
                    process.env.ACTOR_SERVICE +
                        "staff?provider=1&exclude_default"
                )
                .then(function (response) {
                    if (response.data.response.resources) {
                        self.staffList = response.data.response.resources;
                    }
                    return self.staffList;
                });
        },
        async getTriageList() {
            await TriageService.getTriageTypeLists()
                .then(res => {
                    if (res && res.code === 200) {
                        this.triageOptions = res.resources;
                    } else {
                        throw new Error(
                            "Error: Unable to get the triage list."
                        );
                    }
                })
                .catch(e => {
                    console.error(e);
                    this._message(
                        "Error: Unable to get the triage list.",
                        "danger"
                    );
                });
        },
        async save() {
            let self = this;
            let response = false;
            let staffsID = [];

            if (self.data.staffs.length > 0) {
                $.each(self.data.staffs, function (key, value) {
                    staffsID.push(value.id);
                });
            }

            let valid = await self.$validator.validateAll();
            if (valid) {
                let params = {
                    appointment_id: null,
                    start: "",
                    admitted_for: self.data.note,
                    patient_id: self.data.patient.id,
                    client_id: self.data.patient.actor_id,
                    staff_id: staffsID,
                    template_id: null,
                    room_id: self.data.room,
                    status_id: 1,
                    triage_type_id: self.data.triage_type_id //--- new parameter for triage
                };

                if (params) {
                    this.loading = true;
                    response = await this.$http.post(
                        process.env.BARRACUDA + "schedule/treatment-board",
                        params
                    );

                    if (response.status === 200) {
                        self.loading = false;
                        self.$refs.treatementAdmit.hide();
                        self._message("Patient admitted", "success");
                        self.$root.$emit("treatment-board-refresh", {
                            params: response.data.response
                        });

                        const admitResponse =
                            response?.data?.response?.resources;
                        if (self.data.startTreatment) {
                            // construct active_triage: triage_type_id for start treatment params
                            self.createStartTreatmentObject(admitResponse);

                            self.$nextTick(() => {
                                self.$root.$emit(
                                    "start-treatment",
                                    this.start_treatment_data
                                );
                            });
                        }
                    } else {
                        self.loading = false;
                        self._message("Error saving data", "danger");
                    }
                }
            }
        },
        createStartTreatmentObject(admitResponse) {
            // Ensure active_triage exists
            if (!admitResponse.active_triage) {
                admitResponse.active_triage = {};
            }

            // Set triage_type_id if available
            if (this.data.triage_type_id) {
                admitResponse.active_triage.triage_type_id = this.data.triage_type_id;
            }

            this.start_treatment_data = {
                patient: admitResponse.patient,
                treatment: admitResponse, // Updated admitResponse with active_triage
                clientID: admitResponse.client_id,
                treatmentID: admitResponse.id
            };
        }
    }
};
</script>
